import { Component, inject, input, output } from '@angular/core';
import { UserLoginService } from '../../../service/user-login.service';
import { Branch } from '../../../types';

@Component({
  selector: 'app-suspended-branch-row',
  templateUrl: './suspended-branch-row.component.html',
  standalone: false,
})
export class SuspendedBranchRowComponent {
  private userService = inject(UserLoginService);

  public branch = input.required<Branch>();
  public manageBilling = output<Event>();

  public canManageBilling = () => this.userService.canAccessSuspendedBranchBilling(this.branch().id) && !!this.branch().stripe_customer_id;
}
